import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import { MAIN_SITE_URL } from '@/data/site';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20rich%20warm%20flat%20lay%20of%20diverse%20shopping%20goods%20including%20folded%20terracotta%20and%20amber%20fabrics%20a%20leather%20bag%20sneakers%20and%20small%20accessories%20arranged%20in%20an%20organic%20editorial%20composition%2C%20golden%20afternoon%20light%2C%20deep%20earthy%20tones%20with%20soft%20highlights%2C%20premium%20European%20e-commerce%20aesthetic%2C%20textured%20linen%20surface%2C%20high%20resolution%2C%20no%20text&width=1600&height=900&seq=hero-basetao-v2&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <img
        src={HERO_IMAGE}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 py-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/15 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
          <i className="ri-sparkling-line text-sm leading-none"></i>
          <span className="whitespace-nowrap">{t('home.hero.badge')}</span>
        </span>

        <h1 className="mx-auto mt-6 max-w-3xl font-heading text-3xl font-semibold leading-tight text-white md:text-5xl">
          {t('home.hero.title')}
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          {t('home.hero.subtitle')}
        </p>

        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            {t('buttons.basetaoSpreadsheet')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap rounded-md bg-white px-7 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
          >
            {t('buttons.buyNow')}
          </a>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md">
          <CategoryDropdown />
        </div>

        <p className="mt-6 text-xs text-white/70">{t('home.hero.trust')}</p>
      </div>
    </section>
  );
}